import { Link } from 'react-router';
import { Page } from '@/shared/ui';
import { useDocumentTitle } from '@/shared/lib';

/* The label types on the start page. To add a type: build its page, add its address in app/routes (and PAGES in
   backend/server.js), add it to the menu (widgets/app-shell), then add one entry here. */
const LABEL_TYPES = [
  {
    id: 'sticker-4x6', name: '4 × 6 Sticker', size: '4″ × 6″ thermal sticker', to: '/type1-sticker-4x6.html', badge: 'Most used',
    desc: 'For 4×6 sticker printers. Portrait or landscape, one or two products per sticker, with QR code, direction arrow and Code 39 barcode.',
    viz: <><span className="paper" style={{ width: 34, height: 50 }}><i /></span><span className="paper" style={{ width: 50, height: 34 }}><i /></span></>,
  },
  {
    id: 'letter-sheets', name: 'Letter Sheets', size: '8.5″ × 11″ paper', to: '/type2-letter-sheets.html', badge: '',
    desc: 'Print 1, 2, 4 or 8 labels per US Letter page with dashed cut guides. Best for shelf tags run off a standard office printer.',
    viz: <>
      <span className="paper" style={{ width: 38, height: 50 }}><i /><i /></span>
      <span className="paper row" style={{ width: 44, height: 50 }}>
        <span className="paper" style={{ width: '100%', height: '100%', border: 'none', padding: 0 }}><i /><i /></span>
        <span className="paper" style={{ width: '100%', height: '100%', border: 'none', padding: 0 }}><i /><i /></span>
      </span>
    </>,
  },
  {
    id: 'price-stickers', name: 'Price Stickers', size: '62 mm Brother label roll', to: '/price-stickers', badge: 'New',
    desc: 'Small price stickers for catalogue pages, printed on the Brother label printer. 1 or 2 per row, 7 heights, any font size.',
    viz: <>
      <span className="paper" style={{ width: 54, height: 14 }}><i /></span>
      <span className="paper row" style={{ width: 54, height: 14 }}><i /><i /></span>
    </>,
  },
];

// The start page: a card for each label type.
export function HomePage() {
  useDocumentTitle("Uncle Wiener's Wholesale — Label Studio");
  return (
    <Page title="Choose a label type">
      <p className="intro">Retail labels and price tags. Pick the paper you're printing on; you can fill each label in by hand or straight from the website by SKU.</p>
      <div className="tool-grid">
        {LABEL_TYPES.map((t) => (
          <Link key={t.id} className="tool" to={t.to} data-type={t.id}>
            {t.badge && <span className="badge warn">{t.badge}</span>}
            <span className="tool-viz" aria-hidden="true">{t.viz}</span>
            <b>{t.name}</b>
            <span className="size">{t.size}</span>
            <span className="desc">{t.desc}</span>
            <span className="go">Open <span aria-hidden="true">&nbsp;→</span></span>
          </Link>
        ))}
        <div className="tool soon">
          <b>More types<br />coming soon</b>
          <span className="desc">Shelf talkers, clearance tags, bin labels &amp; more.</span>
        </div>
      </div>
    </Page>
  );
}
